import React, { useState,useContext,useEffect } from 'react'
import Card from '../../../Components/Advisor/AdvisorPageCard/Card'
import Layout from '../../../Components/AdvisorLayout'
import MainMenu from '../../../Components/MainMenu'
import Table from '../../../Components/TransactionAdvisor/AllT_TableComponent'
import FilterTag from '../../../Components/Tag'
import RefineSearch from '../../../Components/RefineSearchComponent'
import AdvisorExistsRefineSearch from '../../../Components/RefineSearch/AdvisorExistsRefineSearch'
import MonthPickerComponent from "../../../Utils/MonthPickerComponent";
import xls from "../../../images/xls/png/Group 47.png";
import FileIcon from "../../../images/file.png";
import FileIconBlur from "../../../images/fileblur.png";
import line from "../../../images/line.png";
import moment from "moment";
import SavedFilterContent from "../../../Components/SavedFilter";
import SavedFilterICON from "../../../Components/SavedFilter/SavedFilterICON";
import ExportPopup from "../../../Components/ExportPopup";
import {  transactionAdvisorexitExportData } from "../../../Components/ExportPopup/ExportData"
import { exportAdvisorExcel } from "../../../Config/config";
import Constants from '../../../Constants'
import { useLocation } from 'react-router-dom'
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import { UserContext } from '../../../Contexts/UserContext'
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from 'antd'
import { RiMailDownloadLine } from 'react-icons/ri'
import DownloadTrigger from '../../../Components/ExportPopup/DownloadTrigger'
/* The above code is a React component called "Advisor". It is a part of a larger application and is
responsible for rendering a page that displays a table of advisors. */
function Advisor() {

  // const [save, setSave] = useState(false);
  const {save, setSave ,refineSearchFilters,groupId,showMonthPicker, isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
  // const [showModal, setShowModal] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);

  const savedList = () => {
    setSave(!save);
  };
  const { isStudent,isTrialExport} = useContext(UserContext)

const location = useLocation()
const { pathname } = useLocation(); 
const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

  return (
    <>
      <Layout active={4}>
        <div className="flex h-screen flex-col">
          {/* Bottom section */}
          <div className="flex min-h-0 flex-1 overflow-hidden">
            {/* Narrow sidebar*/}
            {/* Main area */}
            <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex ":"min-w-0 mt-14 flex-1 border-t border-gray-200 flex" }>
              {/* Primary column */}
              <section
                className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last bg-[#EDEDED]"
              >
                {/* Your content */}
                <div></div>
                <div className="pl-3 pr-4 lg:pr-4 md:pr-5">
                  <div className="scrollbar  rounded shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                    <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between  ">
                      <div></div>
                      {isFromGlobalSearch() || groupId?.myList?.length > 0 ? ""
                      :
                      <div className={"justify-between items-center px-2 py-2 space-x-4 "+(showMonthPicker!=0 ? 'md:flex':'flex')}>
                      <div></div>
                      <div className="flex space-x-3">

                      {isTrialExport == 'false' || isStudent === 'true'  || isFromGlobalSearch()? <></>  : <>
                          <button>
                              <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                            {showPopup && (
                              <ExportPopup
                                modules="advisor"
                                module="transaction-advisor"
                                fileName={Constants.exportNames.pe_t_advisor_exit_pm}
                                url={exportAdvisorExcel}
                                onClose={() => setShowPopup(false)}
                                exportOptions={transactionAdvisorexitExportData}
                                type="pe_pm_exit" module_type="pe" advisor_type="T" />
                              // <div>
                              //   <ExcelPopup
                              //     menu="investments"
                              //     subMenu="pevc"
                              //     showPop={showPopup}
                              //     setShowPop={setShowPopup}
                              //   />{" "}
                              // </div>
                            )}
                          </button>

                        </>}

                      </div>
                    </div>
                      }
                     
                    </div>
                    {/* {save ? <SavedFilterContent data={save} /> : ""} */}
                  </div>
                </div>
                <div className='overflow-y-auto'>
                  <Table menu="pe_vc_pm_advisor" advisor_type="T" sub_type_master_id={Constants.subCategoryIds.pe_tadvisor_exitspm_id}/>
                </div>
              </section>
            </main>
          </div>          
        </div>
      </Layout>
    </>
  )
}

export default Advisor
